export function removeBr(str: string): string {
  // 全ての改行コードを削除
  return str.replace("\n", " ").replace("\r", " ").replace("\r\n", " ");
}

export function removeSpace(str: string): string {
  // 全ての空白を削除（半角全角）
  return str.replace(" ", "").replace("　", "");
}

export function cordinateSpace(text: string, format: string = "半角") {
  if (format == "半角") {
    return text.replace("　", " ").replace(" ", " ");
  } else {
    return text.replace(" ", "　").replace("　", "　");
  }
}

export function cordinateBracket(text: string, format: string = "(") {
  if (format == "[") {
    return text.replace("（", "[").replace("）", "]").replace("(", "[").replace(")", "]");
  } else if (format == "(") {
    return text.replace("（", "(").replace("）", ")").replace("[", "(").replace("]", ")");
  } else if (format == "（") {
    return text.replace("(", "（").replace(")", "）").replace("[", "（").replace("]", "）");
  } else {
    return text
      .replace("（", "")
      .replace("）", "")
      .replace("[", "")
      .replace("]", "")
      .replace("(", "")
      .replace(")", "");
  }
}

export function getSeqGroups(numbers: number[]): number[][] {
  if (numbers.length === 0) return [];

  const result: number[][] = [];
  let currentGroup: number[] = [numbers[0]];

  for (let i = 1; i < numbers.length; i++) {
    if (numbers[i] === numbers[i - 1] + 1) {
      // 連続している場合は現在のグループに追加
      currentGroup.push(numbers[i]);
    } else {
      // 連続していない場合は新しいグループを開始
      result.push(currentGroup);
      currentGroup = [numbers[i]];
    }
  }
  // 最後のグループを追加
  result.push(currentGroup);

  return result;
}

export function judgeQuestionId(text: string) {
  return text.startsWith("Q") || text.startsWith("F") || text.startsWith("SQ");
}
